import axiosInstance from "../AxiosInstance";

export function getRestaurantSettings(step, getAllDishes) {
  const params = { step: step, get_all: getAllDishes};
  return axiosInstance.get(`/api/management/settings`, {params: params});
}

export function submitRestaurantSettings(parameters) {
  let params = {};
  if (parameters.upload) {
    params = new FormData();
    parameters.restaurant.photos.forEach((file) => {params.append("restaurant[photos_attributes][]picture", file)});
    params.append('step', parameters.step);
    params['headers'] = {'Content-Type': 'multipart/form-data' };
  } else {
    params = {restaurant: parameters.restaurant, step: parameters.step};
  }
  return axiosInstance.put(`/api/management/settings`, params);
}

export function submitDishSettings(parameters, category_id) {
  const params = {dish: parameters, category_id: category_id};
  return axiosInstance.put(`/api/management/settings/dishes/${parameters.id}`, params);
}

export function saveDishName(parameters, category_id) {
  const params = {dish: parameters, category_id: category_id};
  return axiosInstance.put(`/api/management/settings/dishes/${parameters.id}/update_name`, params);
}

export function submitDishesPositionsSettings(parameters, category_id) {
  const params = {dishes: parameters, category_id: category_id};
  return axiosInstance.put(`/api/management/settings/dishes/update_positions`, params);
}

export function submitDishPhoto(dish_id, file, upload, catIndex) {
  let params = {};
  if (upload) {
    params = new FormData();
    params.append("dish[picture]", file);
    params.append('category_id', catIndex);
    params['headers'] = {'Content-Type': 'multipart/form-data' };
  } else {
    params = {dish: {picture_url: file}, category_id: catIndex};
  }
  return axiosInstance.put(`/api/management/settings/dishes/${dish_id}`, params);
}

export function submitCategoryPhoto(categoryId, file, upload) {
  let params = {};
  if (upload) {
    params = new FormData();
    params.append("category[picture]", file);
    params['headers'] = {'Content-Type': 'multipart/form-data' };
  } else {
    params = {category: {picture_url: file}};
  }
  return axiosInstance.put(`/api/management/settings/categories/${categoryId}`, params);
}

export function destroyCategoryPhoto(id) {
  return axiosInstance.delete(`/api/management/settings/categories/${id}/destroy_picture`);
}

export function destroyDish(dish_id) {
  return axiosInstance.delete(`/api/management/settings/dishes/${dish_id}`);
}

export function createDish(value) {
  const params = {dish: {name: value}};
  return axiosInstance.post(`/api/management/settings/dishes`, params);
}

export function createCategory(value) {
  const params = {category: {name: value}};
  return axiosInstance.post(`/api/management/settings/categories`, params);
}

export function createNewService(value) {
  const params = {service: {name: value}};
  return axiosInstance.post(`/api/management/settings/services`, params);
}

export function getServices(value) {
  return axiosInstance.get(`/api/management/settings/services`, {params: {name: value}});
}

export function postService(values) {
  return axiosInstance.post(`/api/management/settings/services/create_restaurant_service`, {service: values});
}

export function putService(service, values) {
  return axiosInstance.put(`/api/management/settings/services/${service}`, {service: values});
}

export function addUserToService(email, serviceId) {
  return axiosInstance.put(`/api/management/settings/services/${serviceId}/create_role`, {user: {email: email}});
}

export function destroyService(id) {
  return axiosInstance.delete(`/api/management/settings/services/${id}`);
}

export function removeUserFromService(user, service) {
  return axiosInstance.delete(`/api/management/settings/services/${service}/destroy_person`, {params: {user_id: user}});
}

export function submitNewDish(parameters) {
  return axiosInstance.post(`/api/management/settings/dishes/create_dish_restaurant`, {dish: parameters});
}

export function submitOrderSettings(parameters) {
  const params = {restaurant: parameters.restaurant, step: parameters.step};
  return axiosInstance.put(`/api/management/settings`, params);
}

export function submitCategorySettings(parameters) {
  return axiosInstance.put(`/api/management/settings/categories/${parameters.id}`, {category: parameters});
}

export function createSubCategory(parameters) {
  return axiosInstance.post(`/api/management/settings/sub_categories`, {sub_category: parameters});
}

export function saveSubCategory(parameters) {
  return axiosInstance.put(`/api/management/settings/sub_categories/${parameters.id}`, {sub_category: parameters});
}

export function deleteSubCategory(id) {
  return axiosInstance.delete(`/api/management/settings/sub_categories/${id}`);
}

export function removeTableSettings(id) {
  return axiosInstance.delete(`/api/management/settings/tables/${id}`);
}

export function deleteUserFromRestaurant(user) {
  return axiosInstance.delete(`/api/management/settings/restaurant_stuffs/${user.id}`);
}

export function addUserToRestaurant(user) {
  const params = {user: {email: user.email, role: user.role}};
  return axiosInstance.post(`/api/management/settings/restaurant_stuffs`, params);
}

export function getRestaurantRooms() {
  return axiosInstance.get(`/api/management/settings/rooms`);
}

export function submitUser(user) {
  const params = {rooms: user.rooms, restaurant_role: {notifications: user.notifications, 
      all_notifications: user.all_notifications}};
  return axiosInstance.put(`/api/management/settings/restaurant_stuffs/${user.id}`, params);
}

export function getRestaurantStuff() {
  return axiosInstance.get(`/api/management/settings/restaurant_stuffs`);
}

export function getRestaurantTables() {
  return axiosInstance.get(`/api/management/settings/tables`);
}

export function getPosterTables() {
  return axiosInstance.get(`/api/management/settings/tables/get_poster`);
}

export function saveTable(parameters, table) {
  return axiosInstance.put(`/api/management/settings/tables/${table.id}`, {table: parameters});
}

export function fixTableMenu(id) {
  return axiosInstance.post(`/api/management/settings/tables/${id}/fix`);
}

export function saveDashboardTable(parameters, table) {
  return axiosInstance.put(`/api/management/settings/tables/${table.id}/update_dashboard`, {table: parameters});
}

export function createTable(value) {
  return axiosInstance.post(`/api/management/settings/tables`, {table: value});
}

export function createRoom(value) {
  return axiosInstance.post(`/api/management/settings/rooms`, {room: {name: value}});
}

export function saveRoom(room) {
  return axiosInstance.put(`/api/management/settings/rooms/${room.id}`, {room: room});
}

export function saveRoomsPositions(parameters) {
  return axiosInstance.put(`/api/management/settings/rooms/update_positions`, {restaurant: parameters});
}

export function saveCategoriesPositions(parameters) {
  return axiosInstance.put(`/api/management/settings/categories/update_positions`, {restaurant: parameters.restaurant});
}

export function getInternetImages(text, start) {
  return axiosInstance.get(`/api/get_web_images`, {params: {text: text, start: start}});
}

export function destroyPhoto(photo) {
  return axiosInstance.delete(`/api/management/settings/photos/${photo}`);
}

export function destroyDishPhoto(id, category_id) {
  const params = {params: {category_id: category_id}};
  return axiosInstance.delete(`/api/management/settings/dishes/${id}/destroy_picture`, params);
}

// ADMIN zones

export function saveSetting(p) {
  return axiosInstance.post(`/api/admin/zones`, p);
}

export function putSetting(p) {
  return axiosInstance.put(`/api/admin/zones/${p.id}`, p);
}

export function deleteSetting(id) {
  return axiosInstance.delete(`/api/admin/zones/${id}`);
}

export function getSettings() {
  return axiosInstance.get(`/api/admin/zones`);
}

export function changeRzoneSetting(id, params) {
  return axiosInstance.put(`/api/admin/restaurant_zones/${id}`, {zone: params});
}

// END Admin zones

export function getDishPhoto(dishId) {
  return axiosInstance.get(`/api/management/settings/dishes/${dishId}`);
}

export function createDishVariation(dish, dishVariation) {
  const params = {dish_variation: dishVariation};
  return axiosInstance.post(`/api/management/settings/dishes/${dish.id}/dish_variations`, params);
}

export function createBox(parameters) {
  return axiosInstance.post(`/api/management/settings/boxes`, {box: parameters});
}

export function updateBox(parameters) {
  return axiosInstance.put(`/api/management/settings/boxes/${parameters.id}`, {box: parameters});
}

export function deleteBox(parameters) {
  return axiosInstance.delete(`/api/management/settings/boxes/${parameters.id}`);
}

export function updateDishVariation(dishId, dishVariation, field) {
  const params = {dish_variation: {[field]: dishVariation[field]}};
  return axiosInstance.put(`/api/management/settings/dishes/${dishId}/dish_variations/${dishVariation.id}`, params);
}

export function destroyDishVariation(dishId, dishVariationId) {
  return axiosInstance.delete(`/api/management/settings/dishes/${dishId}/dish_variations/${dishVariationId}`);
}

export function copyRestaurantMenu(restaurant) {
  const params = {copy_restaurant_id: restaurant.value};
  return axiosInstance.post(`/api/management/settings/dishes/copy_dishes`, params);
}

export function submitMoveDish(dish, moveDish) {
  const params = {dish: {category_dish_id: moveDish.category.value, sub_category_id: moveDish.sub_category}};
  return axiosInstance.put(`/api/management/settings/dishes/${dish.id}/move_dish`, params);
}

export function saveSubCategoriesPositions(parameters) {
  const params = {sub_categories: {sub_categories_attributes: parameters.positions}, category_dish_id: parameters.category_dish_id};
  return axiosInstance.put(`/api/management/settings/sub_categories/update_positions`, params);
}

export function getCategories(parameters) {
  return axiosInstance.get(`/api/management/settings/categories`, {params: {name: parameters}});
}

export function getDishes(parameters) {
  return axiosInstance.get(`/api/management/settings/dishes`, {params: {name: parameters}});
}

export function getStopList() {
  return axiosInstance.get(`/api/management/settings/dishes/stop_list`);
}

export function stopListSearch(string) {
  return axiosInstance.get(`/api/management/settings/dishes/stop_list_search`, {params: {search: string}});
}

export function receivePosterMenu() {
  return axiosInstance.get(`/api/management/settings/get_poster_menu`);
}

export function getTelegramMessages() {
  return axiosInstance.get(`/api/admin/telegram_messages`);
}

export function sendTelegramMessage(text, chat_id) {
  const params = {message: {text: text}, chat_id: chat_id};
  return axiosInstance.post(`/api/admin/telegram_messages`, params);
}

export function getDeliveryUsers(page) {
  const params = {page: page || 1};
  return axiosInstance.get(`/api/admin/users`, {params: params});
}

export function setUser(user, params) {
  return axiosInstance.put(`/api/admin/users/${user.id}`, params);
}

export function destroyUser(user) {
  return axiosInstance.delete(`/api/admin/users/${user.id}`);
}

export function getIsolines(params) {
  return axiosInstance.get(`/api/admin/zones/isolines`, {params: params});
}

export function getAdminMenu() {
  return axiosInstance.get(`/api/management/settings/dishes/menu`);
}

export function getOnlyCheckboxDishes() {
  return axiosInstance.get(`/api/management/settings/dishes/menu`, {params: {only_checkbox: true}});
}